import {MemberModel} from './user.model';
import {CompanyModel, TCompanyType} from './company.model';
import {FinanceProfileModel, IBankOwner, TPaymentData} from './finance.model';
import {ValuePropertyModel} from './property.model';
import { IMemberWithState, ITagData } from '../modules/contracts/models/contract-internal-models';

export class ContractWrapperModel {
    public contract: ContractModel;
    public members_empty_project: ContractMemberModel[];
    public privates: TPrivateContractModel[];
    public projects: CompanyContractModel[];
    public roadmap_active: ContractRoadmapModel;
    public roadmap_history: ContractRoadmapModel[];
}

export class ContractModel {
    public STATUSES_LIST = {
        OPEN: 'open',
        VERIFIED: 'verified',
        COMPLETED: 'completed',
        CLOSE: 'close',
        PAUSE: 'pause',
        RENEGOTIATED: 'renegotiated',
    };

    public guid: string;
    public name: string;
    public description: string;

    /** данные о проекте контракта (мастер) */
    public master_project: CompanyModel;

    /** статус контракта */
    public status: string;
    public status_at: string;

    /** Является ли этот контракт субконтрактом */
    public is_sub_contract: boolean;

    /** Дата подписания */
    public verified_at: string;
    /** Дата создания */
    public created_at: string;
    /** Дата завершения */
    public completed_at: string;

    /** GUID пользователя */
    public creator_guid: string;

    /** GUID контракта, в котором текущий контракт является субконтрактом */
    public parent_contract_guid: string;

    /** Имеет ли контракт субконтракты */
    public is_parent_for_any_contract: boolean;

    /** Может ли контракт быть переподписан */
    public can_be_renegotiated: boolean;

    /** Исходный переподписанный контракт */
    public original_contract: ContractModel;
    public updated_at: string;

    public custom_properties: ValuePropertyModel[];
}

export interface ContractMemberModel {
    /** право на подпись */
    can_verify: boolean;
    verified_at: string;
    member: MemberModel;
}

export class ContractRoadmapModel {
    guid: string;
    steps?: ContractStepModel[];
    creator: MemberModel;
    created_at: string;
    updated_at: string;

    constructor(step?: ContractStepModel[]) {
        step ? this.steps = step : null
    }
}


export class ContractStepModel {///aaaa
    public TARGET_LIST?: any = {
        FILE: 'file',
        COLLECTION: 'collection',
        TASK: 'task',
        PAYMENT: 'payment',
    };

    /** дата исполнения (null - не исполнен) */
    public completed_at?: any;

    public deadline_at?: string | null;
    public description?: string | null;
    public guid: string | null;
    public name?: string|null;
    public auto_name?: string|null;
    public sort_index?: number;
    public target?: StepTarget | null;

    /** уникальный идентификатор GUID цели */
    public target_key?: string | null;

    /** тип цели TARGET_LIST */
    public target_type?: string;

    public members_signed_step?: {
        created_at: string,
        member_guid: string,
    }[] = [];

    public element?: any;

    public targetName?: string;

    public payment_data?: TPaymentData | null;

    public multi_payment_data?: TPaymentData[];
    public tagData?:ITagData|null
    public membersAvatarsToShow?:IMemberWithState[]|null
}

interface StepTarget {
    created_at?: string;
    guid?: string;
    is_verified?: boolean;
    master_project?: {
        guid: string,
        project_name: string
    };
    payer_project_guid?: string;
    payer_project?: CompanyContractModel;
    payer_private?: TPrivateContractModel;
    target_key?: string;
    target_type?: string;
    verified_at?: string;
    target_status?: string;
}

interface CompanyContractMembersModel {
    observers: ContractMemberModel[];
    signatories: ContractMemberModel[];
}

export type TPrivateContractModel =
    Pick<CompanyContractModel, 'created_at' | 'credit_letter_guid' | 'verified_at' | 'wallet_guid'>
    & { member: MemberModel }

export interface CompanyContractModel {
    project: CompanyModel;
    members: CompanyContractMembersModel;
    credit_letter_guid: string;

    /** все представители проекта подписали контракт (дата) */
    verified_at: string;
    created_at: string;
    wallet_guid: string;
}


export class PaymentTransactionModel {
    public guid: string;

    public payer: CompanyModel;
    public payer_type?: TCompanyType;
    public payer_guid: string | null;
    public payer_account_guid: string;

    public recipient: CompanyModel;
    public recipient_type?: TCompanyType;
    public recipient_guid: string | null;
    public recipient_account_guid: string;

    public total: string | number;

    public payment_hash: string;
    public payment_status: string;

    public updated_at: string;
    public created_at: string;
    public execution_date: string;

    public filter?: string;
    public contract: {
        guid: string;
    }
}
export class PaymentTransactionModel_Opt {
    public guid?: string;

    public payer?: CompanyModel;
    public payer_type?: TCompanyType;
    public payer_guid: string | null;
    public payer_account_guid?: string;

    public recipient?: CompanyModel;
    public recipient_type?: TCompanyType;
    public recipient_guid: string | null;
    public recipient_account_guid?: string;

    public total: string | number;

    public payment_hash?: string;
    public payment_status?: string;

    public updated_at?: string;
    public created_at?: string;
    public execution_date?: string;

    public filter?: string;
    public contract?: {
        guid: string;
    }
}

export interface CreditLetterModel {
        bank_owner:IBankOwner
    contract: { guid: string };
    guid: string;
    owner_guid:string,
    owner_type:TCompanyType,
    owner_name?:string
    payment: PaymentTransactionModel;
    project: FinanceProfileModel;
    total: string;
}

export interface IContractPaginationResponse {
    current_page: number,
    data: ContractModel[],
    page_count: number,
    total:number
}
export interface IConractMember {
    can_verify: boolean,
    member: {guid: string}
    participant_type: string,
    verified_at:string
}